'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'success',
  aliases: ['filled-check', 'filled-tick'],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF058',
    glyphName: 'ok_sign',
    transform: 'scale(1,-1) translate(0, -1536)',
    horizAdvX: '1536',
    d: 'M1284 802q0 28 -18 46l-91 90q-19 19 -45 19t-45 -19l-408 -407l-226 226q-19 19 -45 19t-45 -19l-91 -90q-18 -18 -18 -46q0 -27 18 -45l362 -362q19 -19 45 -19q27 0 46 19l543 543q18 18 18 45zM1536 640q0 -209 -103 -385.5t-279.5 -279.5t-385.5 -103t-385.5 103\nt-279.5 279.5t-103 385.5t103 385.5t279.5 279.5t385.5 103t385.5 -103t279.5 -279.5t103 -385.5z'
  }),
  viewBox: '0 128 1536 1536'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/success.js
// module id = 1600
// module chunks = 0